import { useEffect, useState } from "react";
// import ApiService from "../../utils/ApiService";
import { useDispatch, useSelector } from "react-redux";

import { Button, Form, Input, Modal, Row, Space, Spin, Table } from "antd";
import moment from "moment";

// import {useHistory} from "react-router-dom";
import Swal from "sweetalert2";

import partnersApi from "../../apis/Partners.api";
import { toastAlert } from "../../components/AlertComponent";
import LinkComponent from "../../components/layout/LinkComponent";
import UserManageNav from "../../components/userManageGroup/userManageNav";
import { setLoading } from "../../redux/store/common/commonDuck";

// const api = new ApiService();
const GroupBuying = () => {
	// const history = useHistory();
	const dispatch = useDispatch();
	const user = useSelector((state) => state.auth.user);

	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [groupNav, setGroupNav] = useState("in");
	const groupNavList = [
		{ id: "in", title: "참여중" },
		{ id: "out", title: "참여 신청 전" },
	];
	const columns = [
		{
			title: "구분 (단위: 박스)",
			dataIndex: "option_title",
			key: "option_title",
			ellipsis: true,
			// width: "55%",
		},
		{
			title: "정상가",
			dataIndex: "price_1",
			key: "price_1",
			ellipsis: true,
			// width: "55%",
			render: (value) => {
				if (value) {
					return <span>{value?.toLocaleString()}원</span>;
				}
			},
		},
		{
			title: "기획가",
			dataIndex: "price_2",
			key: "price_2",
			ellipsis: true,
			// width: "55%",
			render: (value) => {
				if (value) {
					return <span>{value?.toLocaleString()}원</span>;
				}
			},
		},
		{
			title: "공구가",
			dataIndex: "price_3",
			key: "price_3",
			ellipsis: true,
			className: "blue-tbody",
			// width: "55%",
			render: (value) => {
				if (value) {
					return <span>{value?.toLocaleString()}원</span>;
				}
			},
		},
		{
			title: "박스 당 환산가",
			dataIndex: "conversion_price_per_unit",
			key: "conversion_price_per_unit",
			ellipsis: true,
			// width: "55%",
			render: (value) => {
				if (value) {
					return <span>{value?.toLocaleString()}원</span>;
				}
			},
		},
		{
			title: "정가대비 할인율",
			dataIndex: "discount_rate_by_list_price",
			key: "discount_rate_by_list_price",
			ellipsis: true,
			// width: "55%",
			render: (value) => {
				if (value) {
					return <span>{value?.toFixed(2)}</span>;
				}
			},
		},
		{
			title: "기획가대비 할인율",
			dataIndex: "discount",
			key: "discount",
			ellipsis: true,
			className: "blue-tbody",
			// width: "55%",
			render: (value) => {
				if (value) {
					return <span>{value?.toFixed(0)}%</span>;
				}
			},
		},
		{
			title: "수수료율",
			dataIndex: "commission_rate",
			key: "commission_rate",
			ellipsis: true,
			className: "red-tbody",
			// width: "55%",
			render: (value) => {
				return <span>{value?.toFixed(0)}%</span>;
			},
		},
	];
	const [groupBuyingList, setGroupBuyingList] = useState([]);

	const [smsCount, setSmsCount] = useState(0);
	const [smsSendShow, setSmsSendShow] = useState(false);
	const [smsMessage, setSmsMessage] = useState("");

	useEffect(() => {
		window.scrollTo({
			top: 0,
		});
	}, []);

	useEffect(() => {
		getGroupList();
		getSMSCount();
	}, [user, groupNav]);

	/**
	 * 공동구매 목록 가져오기
	 * @returns {Promise<void>}
	 */
	const getGroupList = async () => {
		setIsLoading(true);
		let param = {
			influencerId: user.id,
			status: groupNav,
		};
		const res = await partnersApi.readGroupBuyingListInfluencer(param);
		if (res.code === 200) {
			setGroupBuyingList(res.result);
		}
		setIsLoading(false);
	};

	/**
	 * 공동구매 참여/참여 취소
	 * @param item
	 * @param status
	 * @returns {Promise<void>}
	 */
	const updateGroupBuying = async (item, status) => {
		setIsLoading(true);
		let param = {
			cooperate_id: item.cooperate_id,
			influencer_id: user.id,
			status: status,
		};
		// console.log(param, item);
		const res = await partnersApi.postGroupBuying(param);
		// console.log(res);
		if (res.code === 200) {
			getGroupList();
		}
		setIsLoading(false);
	};

	/**
	 * sms 발송 가능 회원 수
	 * @returns {Promise<void>}
	 */
	const getSMSCount = async () => {
		let param = {
			userId: user.id,
		};
		const res = await partnersApi.smsReadCount(param);
		if (res.code === 200) {
			setSmsCount(res.result ?? 0);
		}
	};

	const clickMessageButton = () => {
		getSMSCount();
		setSmsSendShow(!smsSendShow);
	};

	/**
	 * sms 메시지 보내기
	 * @returns {Promise<void>}
	 */
	const sendMessage = async () => {
		setIsLoading(true);
		let param = {
			influencer_id: user.id,
			content: smsMessage,
		};
		const res = await partnersApi.postSmsSend(param);
		if (res.code === 200) {
			Swal.fire({
				customClass: "alert-custom",
				text: "전송이 완료되었습니다.",
				confirmButtonText: "확인",
			}).then(() => {
				setSmsSendShow(false);
			});
		}
		setIsLoading(false);
	};

	const handleCopyLink = (e) => {
		let url =
			"https://www.dangyoung.com/products/group_buying/" +
			e.currentTarget.value;
		window.navigator.clipboard.writeText(url).then(() => {
			toastAlert("링크 복사가 완료 되었습니다.");
		});
	};

	return (
		<div className="main-wrap">
			<div className="max-width-apply">
				<LinkComponent />

				<h1 className="main-title">회원 관리</h1>

				<UserManageNav />

				<Space wrap className={`group-buying-nav`}>
					{groupNavList.map((item, idx) => (
						<Button
							key={`공동구매 참여 여부 ${idx}`}
							className={`${
								groupNav === item.id ? "group-nav clicked" : "group-nav"
							}`}
							onClick={() => {
								setGroupNav(item.id);
							}}
							size={"large"}
						>
							{item.title}
						</Button>
					))}
				</Space>

				{/* 상품 리스트 표기 */}
				{isLoading ? (
					<Spin style={{ margin: "auto", width: "100%", paddingTop: "2em" }} />
				) : (
					<div className={`main-body`}>
						{groupBuyingList?.length > 0 ? (
							<>
								<h3 className={`body-title`}>
									{groupNav === "in" ? "참여중" : "참여 신청 전"} 목록
									<span
										style={{
											color: "#117ffa",
											fontWeight: "bold",
											marginLeft: "3px",
										}}
									>
										{groupBuyingList?.length}
									</span>
									개
								</h3>

								{groupBuyingList?.map((item, idx) => (
									<div
										className={`group-buying-list-wrap ${
											idx === 0 ? "first-wrap" : ""
										}`}
										key={`공동구매 상품 리스트 ${idx}`}
									>
										<div className={`group-buying-list-product`}>
											<div className={`product-information`}>
												<Row align={"middle"} style={{ gap: "5px" }}>
													<p className={`group-${item?.cooperate_status}`}>
														{item?.cooperate_status === 0
															? "진행중"
															: "진행예정"}
													</p>
													<p className={`group-buying-gray`}>
														{moment(item?.cooperate_start_date).format(
															"YYYY.MM.DD"
														)}
														-{moment(item?.cooperate_end_date).format("MM.DD")}
													</p>
												</Row>
												<p className={`group-buying-title`}>
													{item?.product_brand_name} {item?.product_name}
													{item?.product_category_name
														? ` (${item?.product_category_name})`
														: ""}
												</p>
												{Array.from({ length: 6 }).map((description, idx) => {
													if (item[`information_${idx + 1}`])
														return (
															<p
																className={`group-buying-gray`}
																key={`공동구매 설명 ${idx}`}
															>
																{`${idx + 1}) ${
																	item[`information_${idx + 1}`]
																}`}
															</p>
														);
												})}
												<a
													href={`https://www.dangyoung.com/products/${item.target_id}`}
													target={"_blank"}
													style={{ marginTop: "3px", color: "#117ffa" }}
												>
													제품 자세히 보기 >
												</a>
												{item?.cooperate_query && (
													<Button
														size={`small`}
														style={{ fontSize: "1em" }}
														loading={isLoading}
														value={`${item.target_id}?query=${item.cooperate_query}`}
														onClick={handleCopyLink}
													>
														공동구매 링크 복사하기
													</Button>
												)}
											</div>
											<img
												src={`${process.env.REACT_APP_S3_HOST}/image/recommend/${item.target_id}.jpg`}
												onError={({ currentTarget }) => {
													currentTarget.onerror = null; // prevents looping
													currentTarget.src = `/assets/images/no-product.png`;
												}}
												className={`group-buying-image`}
												alt={`${item.title}`}
											/>
										</div>

										<Table
											dataSource={item?.cooperateOptionList.map((option) => ({
												...option,
												commission_rate: item.commission_rate,
											}))}
											className="group-buying-table"
											columns={columns}
											pagination={false}
										/>

										{groupNav === "in" ? (
											<div className={`group-buying-button-group`}>
												<Button
													size={`small`}
													className={`black-btn`}
													loading={isLoading}
													onClick={clickMessageButton}
												>
													알림 보내기
												</Button>
												<Button
													size={`small`}
													className={`white-btn`}
													loading={isLoading}
													onClick={() => updateGroupBuying(item, "out")}
												>
													참여 취소
												</Button>
											</div>
										) : (
											<div className={`group-buying-button-group`}>
												<Button
													size={`small`}
													className={`black-btn`}
													loading={isLoading}
													onClick={() => updateGroupBuying(item, "in")}
												>
													참여하기
												</Button>
											</div>
										)}
									</div>
								))}
							</>
						) : (
							<Row
								align={"middle"}
								style={{
									width: "100%",
									flexDirection: "column",
									padding: "3em 0",
								}}
							>
								<img
									src={`/assets/images/warning.png`}
									alt={`warning-icon`}
									style={{
										width: "4em",
										height: "auto",
									}}
								/>
								<span
									style={{
										marginTop: "1em",
										color: "#adb5bd",
										fontSize: "1.2em",
										fontWeight: 500,
									}}
								>
									일치하는 공동구매 내역이 없습니다.
								</span>
							</Row>
						)}
					</div>
				)}

				{/* sms 메세지 보내기 */}
				<Modal
					title="SMS 메세지 보내기"
					wrapClassName="sms-send-modal"
					open={smsSendShow}
					centered={true}
					onCancel={() => setSmsSendShow(!smsSendShow)}
					width="45%"
					footer={
						<Button
							className={`sms-modal-btn`}
							onClick={sendMessage}
							loading={isLoading}
						>
							전송하기
						</Button>
					}
				>
					<Form labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
						<Form.Item label="발송건수" labelAlign="left" colon={false}>
							<Input type={`text`} placeholder={smsCount} disabled={true} />
						</Form.Item>
						<Form.Item label="메세지" labelAlign="left" colon={false}>
							<Input.TextArea
								type={`text`}
								placeholder={`메세지 내용을 입력해주세요`}
								required
								onChange={(e) => setSmsMessage(e.target.value)}
								value={smsMessage}
								showCount={true}
								maxLength={1000}
							/>
						</Form.Item>
						<Form.Item
							label=" "
							labelAlign="left"
							colon={false}
							labelCol={{ span: 6 }}
							wrapperCol={{ span: 18 }}
							style={{ margin: 0 }}
						>
							<p style={{ margin: 0, fontSize: "0.9em", color: "#adb5bd" }}>
								*오전 8시부터 오후 8시까지 전송이 가능합니다.
							</p>
						</Form.Item>
					</Form>
				</Modal>
			</div>
		</div>
	);
};
export default GroupBuying;
